import React from 'react';
import Layout from '../components/Layout';
import PageHeader from '../components/PageHeader';
import SectionHeader from '../components/SectionHeader';
import GoldButton from '../components/GoldButton';
import { MapPin, Phone, Mail } from 'lucide-react';

const Contact = () => {
  return (
    <Layout>
      <PageHeader
        title="Contact Us"
        subtitle="Get In Touch"
        image="https://images.unsplash.com/photo-1540760029765-138c8f6d2eac?q=80&w=2070&auto=format&fit=crop"
      />

      <section className="py-24 bg-background">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-16 mb-24">
            {/* Contact Info */}
            <div data-aos="fade-right">
              <SectionHeader title="Reach Out" subtitle="Contact Information" align="left" className="mb-8" />
              <p className="text-muted-foreground mb-12">
                Whether you have a question about our services, projects, or want to discuss a new partnership, our team is ready to answer all your questions.
              </p>

              <div className="space-y-8">
                <div className="flex items-start gap-6">
                  <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center text-primary shrink-0">
                    <MapPin size={24} />
                  </div>
                  <div>
                    <h4 className="text-xl font-serif font-bold text-foreground mb-2">Head Office</h4>
                    <p className="text-muted-foreground">
                      D3/D4 – Dolphin Garden, Opp. Su-Swagat Hotel,<br/>
                      Poonam Sagar, Mira Road East,<br/>
                      Mumbai – 401107.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-6">
                  <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center text-primary shrink-0">
                    <Phone size={24} />
                  </div>
                  <div>
                    <h4 className="text-xl font-serif font-bold text-foreground mb-2">Phone</h4>
                    <p className="text-muted-foreground">7030132885</p>
                  </div>
                </div>

                <div className="flex items-start gap-6">
                  <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center text-primary shrink-0">
                    <Mail size={24} />
                  </div>
                  <div>
                    <h4 className="text-xl font-serif font-bold text-foreground mb-2">Email</h4>
                    <p className="text-muted-foreground">sandhya@totoinfra.com</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div data-aos="fade-left">
              <div className="bg-card border border-white/5 p-8 md:p-10 rounded-2xl shadow-2xl">
                <h3 className="text-2xl font-serif font-bold text-foreground mb-6">Send us a Message</h3>
                <form className="space-y-6">
                  <div className="grid md:grid-cols-2 gap-6">
                    <div className="space-y-2">
                      <label className="text-sm font-medium text-muted-foreground">Name</label>
                      <input type="text" className="w-full bg-background border border-white/10 rounded-lg px-4 py-3 text-foreground focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-all" placeholder="Your Name" />
                    </div>
                    <div className="space-y-2">
                      <label className="text-sm font-medium text-muted-foreground">Email</label>
                      <input type="email" className="w-full bg-background border border-white/10 rounded-lg px-4 py-3 text-foreground focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-all" placeholder="your@email.com" />
                    </div>
                  </div>
                  <div className="space-y-2">
                    <label className="text-sm font-medium text-muted-foreground">Subject</label>
                    <input type="text" className="w-full bg-background border border-white/10 rounded-lg px-4 py-3 text-foreground focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-all" placeholder="Project Enquiry" />
                  </div>
                  <div className="space-y-2">
                    <label className="text-sm font-medium text-muted-foreground">Message</label>
                    <textarea rows="4" className="w-full bg-background border border-white/10 rounded-lg px-4 py-3 text-foreground focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-all" placeholder="Tell us about your project..."></textarea>
                  </div>
                  <GoldButton className="w-full">Send Message</GoldButton>
                </form>
              </div>
            </div>
          </div>

          {/* Map Section */}
          <div data-aos="fade-up">
            <SectionHeader title="Locate Us" subtitle="Visit Our Office" />
            <div className="w-full h-[450px] rounded-2xl overflow-hidden border border-white/10 shadow-2xl relative group">
              {/* Map Iframe */}
              <iframe
                width="100%"
                height="100%"
                id="gmap_canvas"
                src="https://maps.google.com/maps?q=Ostwal%20Point%20Building%2C%20Opp.%20Shivar%20Garden%2C%20Mira%20Road%20(E)%2C%20Thane&t=&z=15&ie=UTF8&iwloc=&output=embed"
                frameBorder="0"
                scrolling="no"
                marginHeight="0"
                marginWidth="0"
                title="TOTO INFRA Office Map"
                className="grayscale group-hover:grayscale-0 transition-all duration-700"
              ></iframe>

              {/* Decorative Overlay (fades out on hover) */}
              <div className="absolute inset-0 bg-primary/10 pointer-events-none group-hover:bg-transparent transition-colors duration-700"></div>
            </div>
          </div>

        </div>
      </section>
    </Layout>
  );
};

export default Contact;
